import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment";

export default {
  state: () => ({}),

  mutations: {},

  actions: {
    //TODO: load, update, create

    searchMuhtiras: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/memorandums/search", request).then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          response.data.forEach((muhtira) => {
            muhtira.documentDate = moment(muhtira.documentDate).format("DD.MM.YYYY");
          });
        }
        return response;
      });
    },

    searchMuhtiraDownloads: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/memorandums/search-invoiced", request).then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          response.data.forEach((muhtira) => {
            muhtira.documentDate = moment(muhtira.documentDate).format("DD.MM.YYYY");
          });
        }
        return response;
      });
    },

    updateMuhtiraInvoicedStatus: (context, request) => {
      return axios.put(context.getters.getMcServiceUrl + "/memorandums/invoiced-status", request).then((response) => {
        return response;
      });
    },

    createMuhtira: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/memorandums/entity", request).then((response) => {
        return response;
      });
    },

    updateMuhtira: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/memorandums/entity", request).then((response) => {
        return response;
      });
    },

    deleteMuhtira: (context, request) => {
      return axios.delete(context.getters.getMcServiceUrl + "/memorandums/entity/" + request.id).then((response) => {
        return response;
      });
    },

    loadMuhtiraHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/memorandums/history/" + request.id).then((response) => {
        return response.data;
      });
    },

    checkValidationForMuhtira: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/use-memorandum-simulation", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {},
};
